import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useUnreadMessages } from '@dialectlabs/react-sdk';
import clsx from 'clsx';
import { useRef } from 'react';
import { useOutsideAlerter } from '../../utils/useOutsideAlerter';
import { DEFAULT_NOTIFICATIONS_CHANNELS } from '../common/constants';
import { useTheme } from '../common/providers/DialectThemeProvider';
import { useDialectUiId } from '../common/providers/DialectUiManagementProvider';
import IconButton from '../IconButton';
import NotificationsModal from '../NotificationsModal';
const DEFAULT_POLLING_FOR_NOTIFICATIONS = 15000; // 15 sec refresh default
function WrappedNotificationsButton(props) {
    const { dappAddress } = props;
    const { ui, open, close } = useDialectUiId(props.dialectId);
    const { colors, bellButton, icons } = useTheme();
    const { hasUnreadMessages } = useUnreadMessages({
        otherMembers: dappAddress ? [dappAddress] : [],
        refreshInterval: props.pollingInterval,
    });
    const refs = useRef([]);
    useOutsideAlerter(refs, close);
    return (_jsxs("div", { className: clsx('dt-flex dt-flex-col dt-items-end dt-relative', colors.textPrimary), children: [hasUnreadMessages && (_jsx("div", { className: clsx('dt-absolute dt-h-3 dt-w-3 dt-z-50 dt-rounded-full', colors.notificationBadgeColor) })), _jsx(IconButton, { ref: (el) => {
                    if (!el)
                        return;
                    refs.current[0] = el;
                }, className: clsx('dt-flex dt-items-center dt-justify-center dt-rounded-full focus:dt-outline-none dt-shadow-md', colors.bg, bellButton), icon: _jsx(icons.bell, { className: clsx('dt-w-6 dt-h-6 dt-rounded-full') }), onClick: (ui === null || ui === void 0 ? void 0 : ui.open) ? close : open }), _jsx(NotificationsModal, { ref: (el) => {
                    if (!el)
                        return;
                    refs.current[0] = el;
                }, ...props })] }));
}
export default function NotificationsButton({ channels = DEFAULT_NOTIFICATIONS_CHANNELS, pollingInterval = DEFAULT_POLLING_FOR_NOTIFICATIONS, ...props }) {
    return (_jsx("div", { className: "dialect", children: _jsx(WrappedNotificationsButton, { channels: channels, pollingInterval: pollingInterval, ...props }) }));
}
//# sourceMappingURL=index.js.map